import { useTranslation } from "react-i18next";
import { Select, Radio, Input, Typography } from "antd";
import { GetDefaultLanguage } from "../../../../utils/urls";
import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { fetchLandingPageCode, editLandingPageCode, fetchClientPROPersonalitationData, editLandingPageOptions, getLoginWidgetScript } from "../../../../api/repositoryEP";
import { Button } from "antd";
import CodeEditor from "../../../codeEditor/CodeEditor";
import { EditLandingPageOptionDto, HTMLBlock, LandingPageCodeData, LandingPageCodeResponse } from "../../../../models/ConfigurationData";
import './LandingPage.scss';
import { LoadingOutlined } from "@ant-design/icons";
import { LoadingData } from "../../../common";
import { Form } from "antd";
import CodeBlock from "../../../common/CodeBlock/CodeBlock";

interface LandingPageProps {
    languages: string[];
}

const LandingPage = (props: LandingPageProps): JSX.Element => {
    const { t } = useTranslation();
    const languages = props.languages;
    const [language, setLanguage] = useState(GetDefaultLanguage());
    const [cssCode, setCssCode] = useState("");
    const [idLandingPage, setIdLandingPage] = useState("");
    const [htmlCode, setHtmlCode] = useState<Array<HTMLBlock>>([]);
    const [useDefaultTemplate, setUseDefaultTemplate] = useState(false);
    const [model, setModel] = useState(0);
    const [externalUrlRedirect, setExternalUrlRedirect] = useState<string>("");
    const [jsCode, setJsCode] = useState("");
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingButton, setLoadingButton] = useState<boolean>(false)

    const [optionSelected, setOptionSelected] = useState<string>("template"); // template, redirect o designed


    useEffect(() => {
        setLoading(true)
        const fetchData = () => {
            fetchClientPROPersonalitationData()
                .then(response => {
                    setUseDefaultTemplate(response?.data.useDefaultTemplate);
                    setModel(response?.data.defaultTemplate);
                    setExternalUrlRedirect(response?.data.externalLandingPageUrl);

                    if (response?.data.externalLandingPageUrl && response?.data.externalLandingPageUrl.trim() !== "") {
                        setOptionSelected("redirect");
                    }
                    else if (response?.data.useDefaultTemplate === true) {
                        setOptionSelected("template");
                    }
                    else {
                        setOptionSelected("designed");
                    }
                })
                .finally(() => {
                    setLoading(false)
                })
        };

        fetchData();
    }, []);



    const handleLanguage = (language: any) => {
        setLanguage(language);
    }
    const [loadingOption, setLoadingOption] = useState<boolean>(false);

    const handleSubmitOptions = (values: any) => {
        const optionsData: EditLandingPageOptionDto = {
            useDefaultTemplate: optionSelected === "template",
            template: optionSelected === "template" ? model : null,
            redirectUrl: optionSelected === "redirect" ? externalUrlRedirect : "",
        };
        setLoadingOption(true);

        editLandingPageOptions(optionsData).then((r) => {
            if (r?.type === 1 && r?.data == true) {
                if (optionSelected === "template") {
                    setExternalUrlRedirect("");
                    form.resetFields(["externalUrlRedirect"]);  // opcional, si usas Form
                }
                const scrollTopElement = document.getElementById("content-page")!;
                scrollTopElement.scrollTop = 0;

            }
        }).finally(() => {
            setLoadingOption(false);
        });
    };


    useEffect(() => {
        if (language) {
            setLoading(true)
            fetchLandingPageCode(language).then((r) => {
                const code: LandingPageCodeResponse = r?.data;
                if (r?.type === 1) {
                    setIdLandingPage(code.id);
                    setCssCode(code.css);
                    setHtmlCode(code.appThemeHtmlBlock);
                    setJsCode(code.javascript);
                }
                setLoading(false)
            })

        }
    }, [language])

    const handleCode = () => {
        const data: LandingPageCodeData = {
            id: idLandingPage,
            language: language,
            cssCode: cssCode,
            htmlCode: htmlCode,
            jsCode: jsCode,
        };
        setLoadingButton(true)
        editLandingPageCode(data).then((r) => {
            if (r?.type === 1) {
                const scrollTopElement = document.getElementById("content-page")!;
                scrollTopElement.scrollTop = 0;
            }
            setLoadingButton(false)
        })
    }

    useEffect(() => {
        if (optionSelected !== "redirect") {
            setExternalUrlRedirect("");
        }
    }, [optionSelected]);

    const [form] = Form.useForm();


const [widgetCode, setWidgetCode] = useState<string>("");
useEffect(() => {
    getLoginWidgetScript().then((r: any) => {
        if (r?.type === 1) {
            setWidgetCode(r.data);
        }
    });
}, []);



    return (
        <div className="landing-page-component">
            {loading ? (<LoadingData />) : (<>
                <Row gutter={4} className='flex-column'>
                    <Col xs={24} style={{ marginBottom: 10 }}>
                        <div className="landing-section-title">
                            {t("components.tab-configuration.landing-page.info")}
                        </div>
                    </Col>

                    <Col xs={24} style={{ marginBottom: 30 }}>
                        <Radio.Group
                            onChange={(e) => setOptionSelected(e.target.value)}
                            value={optionSelected}
                        >
                            <Radio value="template">{t("components.tab-configuration.landing-page.template")}</Radio>
                            <Radio value="redirect">{t("components.tab-configuration.landing-page.redirect")}</Radio>
                            <Radio value="designed">{t("components.tab-configuration.landing-page.designed")}</Radio>
                        </Radio.Group>
                    </Col>

                    {optionSelected === "template" && (
                        <Col xs={24} style={{ marginTop: 16 }}>
                            <Radio.Group
                                onChange={(e) => setModel(e.target.value)}
                                value={model}
                            >
                                <Radio value={0} className="template-radio">
                                    <div className="radio-content">
                                        <span className="text">
                                            {t("components.pro-configuration.landing-1")}
                                        </span>
                                        <div className="image-container">
                                            <img
                                                className="image-config"
                                                src="/images/landing1.png"
                                                alt="Landing template 1"
                                            />
                                        </div>
                                    </div>
                                </Radio>

                            </Radio.Group>
                        </Col>
                    )}

                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={handleSubmitOptions}
                    >

                        {optionSelected === "redirect" && (

                            <Col xs={24} sm={24}>
                                <Form.Item
                                    required
                                    help={t("components.tab-configuration.landing-page.external-url")}
                                    rules={[
                                        {
                                            required: true,
                                            message: t("required") || "",
                                        }
                                    ]}
                                >
                                    <Input
                                        value={externalUrlRedirect}
                                        onChange={(e) => setExternalUrlRedirect(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>



                        )}

                        <Col xs={24} className="button-container-center" style={{ marginTop: optionSelected === 'designed' ? 8 : 32 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="app-button button-large btn-save"
                                loading={loadingOption}
                                disabled={loadingOption}
                            >
                                {t("components.button.save")}
                            </Button>
                        </Col>
                        {optionSelected === "redirect" && (
                            <Col xs={24} style={{ marginTop: 46 }}>
                                <Typography.Text strong>
                                    {t("components.tab-configuration.landing-page.widget-integration-example")}
                                </Typography.Text>
                                <CodeBlock code={widgetCode} />
                            </Col>
                        )}

                        {optionSelected === "designed" && (
                            <>
                                <Col xs={24} sm={24} md={8} lg={6} xl={4}>
                                    <Select
                                        className="select-large"
                                        value={language}
                                        onChange={handleLanguage}
                                    >
                                        {languages.map(language => (
                                            <Select.Option key={language} value={language}>
                                                {t(`languages.${language}`)}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col xs={24} md={24}>
                                    <CodeEditor
                                        htmlCode={htmlCode}
                                        cssCode={cssCode}
                                        jsCode={jsCode}
                                        setHtmlCode={setHtmlCode}
                                        setCssCode={setCssCode}
                                        setJsCode={setJsCode}
                                    />
                                </Col>

                                <Col xs={24} md={24} className="button-container">
                                    <Button
                                        className="app-button button-large btn-save"
                                        onClick={handleCode}
                                        disabled={loadingButton}
                                    >
                                        {loadingButton ? <LoadingOutlined /> : t("components.button.save")}
                                    </Button>
                                </Col>
                            </>
                        )}



                    </Form>

                </Row>
            </>)}
        </div>

    );
};



export default LandingPage;


